import { EMPTY_STRING } from '../../../constants/common'

export const DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME = 'name'

export const DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS = 'set_permission_groups'

export const DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_ADMINS = 'admin'

export const DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_MANAGER = 'manager'

export const DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_LANDLORDS = 'landlord'

export const DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_TENANTS = 'dweller'

export const DOCUMENT_FOLDER_FORM_FIELD_ACCESS_FIELDS = [
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_ADMINS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_MANAGER,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_LANDLORDS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_TENANTS,
]

export const DOCUMENT_FOLDER_FORM_INITIAL_VALUES = {
  [DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME]: EMPTY_STRING,
}

export const STAFF_DOCUMENT_FOLDER_FORM_INITIAL_VALUES = {
  ...DOCUMENT_FOLDER_FORM_INITIAL_VALUES,
  [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS]: {
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_ADMINS]: true,
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_LANDLORDS]: true,
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_MANAGER]: true,
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_TENANTS]: true,
  },
}
